[
  {
    "date": "2025-12-12 21:15:00",
    "open": 3800,
    "low": 3687.67,
    "high": 3977.55,
    "close": 3864.42,
    "volume": 161749116
  },
  {
    "date": "2025-12-12 21:30:00",
    "open": 3864.42,
    "low": 3843.53,
    "high": 3888.98,
    "close": 3850.75,
    "volume": 45165508
  },
  {
    "date": "2025-12-12 21:45:00",
    "open": 3850.75,
    "low": 3637.94,
    "high": 4471.27,
    "close": 4231.46,
    "volume": 146660212
  },
  {
    "date": "2025-12-12 22:00:00",
    "open": 4231.46,
    "low": 3510.79,
    "high": 4766.81,
    "close": 4721.83,
    "volume": 177042515
  },
  {
    "date": "2025-12-12 22:15:00",
    "open": 4721.83,
    "low": 4623.47,
    "high": 4862.69,
    "close": 4800.93,
    "volume": 55740050
  },
  {
    "date": "2025-12-12 22:30:00",
    "open": 4800.93,
    "low": 4730.26,
    "high": 4834.37,
    "close": 4756.87,
    "volume": 61872204
  },
  {
    "date": "2025-12-12 22:45:00",
    "open": 4756.87,
    "low": 4583.48,
    "high": 4770.81,
    "close": 4668.45,
    "volume": 50925177
  },
  {
    "date": "2025-12-12 23:00:00",
    "open": 4668.45,
    "low": 4629.98,
    "high": 4702.94,
    "close": 4695.22,
    "volume": 56086537
  },
  {
    "date": "2025-12-12 23:15:00",
    "open": 4695.22,
    "low": 4562.27,
    "high": 4850.98,
    "close": 4784.99,
    "volume": 72199968
  },
  {
    "date": "2025-12-12 23:30:00",
    "open": 4784.99,
    "low": 4676.21,
    "high": 4887.36,
    "close": 4730.67,
    "volume": 43323939
  },
  {
    "date": "2025-12-12 23:45:00",
    "open": 4730.67,
    "low": 4659.98,
    "high": 4780.59,
    "close": 4774.5,
    "volume": 46392489
  },
  {
    "date": "2025-12-13 00:00:00",
    "open": 4774.5,
    "low": 4654.3,
    "high": 4822.67,
    "close": 4697,
    "volume": 59051450
  },
  {
    "date": "2025-12-13 00:15:00",
    "open": 4697,
    "low": 4625.62,
    "high": 4729.53,
    "close": 4666.1,
    "volume": 57851109
  },
  {
    "date": "2025-12-13 00:30:00",
    "open": 4666.1,
    "low": 4661.03,
    "high": 4672.85,
    "close": 4666.89,
    "volume": 47706996
  },
  {
    "date": "2025-12-13 00:45:00",
    "open": 4666.89,
    "low": 4591.79,
    "high": 4902.39,
    "close": 4892.91,
    "volume": 93437069
  },
  {
    "date": "2025-12-13 01:00:00",
    "open": 4892.91,
    "low": 4872.46,
    "high": 5049.77,
    "close": 4951.27,
    "volume": 52851222
  },
  {
    "date": "2025-12-13 01:15:00",
    "open": 4951.27,
    "low": 4911.48,
    "high": 5022.28,
    "close": 5008.9,
    "volume": 63553981
  },
  {
    "date": "2025-12-13 01:30:00",
    "open": 5008.9,
    "low": 4999.45,
    "high": 5040.21,
    "close": 5018.04,
    "volume": 42717277
  },
  {
    "date": "2025-12-13 01:45:00",
    "open": 5018.04,
    "low": 4960.84,
    "high": 5060.77,
    "close": 4993.42,
    "volume": 51457104
  },
  {
    "date": "2025-12-13 02:00:00",
    "open": 4993.42,
    "low": 4988.27,
    "high": 4998.54,
    "close": 4993.35,
    "volume": 50841278
  },
  {
    "date": "2025-12-13 02:15:00",
    "open": 4993.35,
    "low": 4987.15,
    "high": 4999.65,
    "close": 4994.2,
    "volume": 54208348
  },
  {
    "date": "2025-12-13 02:30:00",
    "open": 4994.2,
    "low": 4836.33,
    "high": 5088.53,
    "close": 4917.18,
    "volume": 44641014
  },
  {
    "date": "2025-12-13 02:45:00",
    "open": 4917.18,
    "low": 4882.8,
    "high": 4984.16,
    "close": 4964.02,
    "volume": 57566725
  },
  {
    "date": "2025-12-13 03:00:00",
    "open": 4964.02,
    "low": 4907.06,
    "high": 5005.87,
    "close": 4931.85,
    "volume": 47930632
  },
  {
    "date": "2025-12-13 03:15:00",
    "open": 4931.85,
    "low": 3280.76,
    "high": 5316.68,
    "close": 4223.41,
    "volume": 166605692
  },
  {
    "date": "2025-12-13 03:30:00",
    "open": 4223.41,
    "low": 4126.71,
    "high": 4293.52,
    "close": 4162.93,
    "volume": 53399918
  },
  {
    "date": "2025-12-13 03:45:00",
    "open": 4162.93,
    "low": 4128.64,
    "high": 4198.23,
    "close": 4189.99,
    "volume": 60089612
  },
  {
    "date": "2025-12-13 04:00:00",
    "open": 4189.99,
    "low": 4134.74,
    "high": 4293.08,
    "close": 4240.45,
    "volume": 48069827
  },
  {
    "date": "2025-12-13 04:15:00",
    "open": 4240.45,
    "low": 4169.21,
    "high": 4271.63,
    "close": 4194.22,
    "volume": 57677619
  },
  {
    "date": "2025-12-13 04:30:00",
    "open": 4194.22,
    "low": 4027.71,
    "high": 4274.69,
    "close": 4112.1,
    "volume": 64365473
  },
  {
    "date": "2025-12-13 04:45:00",
    "open": 4112.1,
    "low": 4096.67,
    "high": 4117.35,
    "close": 4108.27,
    "volume": 48098821
  },
  {
    "date": "2025-12-13 05:00:00",
    "open": 4108.27,
    "low": 4048.83,
    "high": 4183.44,
    "close": 4150.84,
    "volume": 45505594
  },
  {
    "date": "2025-12-13 05:15:00",
    "open": 4150.84,
    "low": 4085.91,
    "high": 4168.87,
    "close": 4099.4,
    "volume": 56695531
  },
  {
    "date": "2025-12-13 05:30:00",
    "open": 4099.4,
    "low": 4026.51,
    "high": 4137.75,
    "close": 4062.02,
    "volume": 59257801
  },
  {
    "date": "2025-12-13 05:45:00",
    "open": 4062.02,
    "low": 3984.75,
    "high": 4084.31,
    "close": 4022.95,
    "volume": 61945157
  },
  {
    "date": "2025-12-13 06:00:00",
    "open": 4022.95,
    "low": 3497.01,
    "high": 4847.94,
    "close": 4379.91,
    "volume": 166163729
  },
  {
    "date": "2025-12-13 06:15:00",
    "open": 4379.91,
    "low": 4305.04,
    "high": 4414.87,
    "close": 4327.58,
    "volume": 48244417
  },
  {
    "date": "2025-12-13 06:30:00",
    "open": 4327.58,
    "low": 4307.74,
    "high": 4432.97,
    "close": 4375.71,
    "volume": 50670322
  },
  {
    "date": "2025-12-13 06:45:00",
    "open": 4375.71,
    "low": 4313.02,
    "high": 4403,
    "close": 4354.68,
    "volume": 55880304
  },
  {
    "date": "2025-12-13 07:00:00",
    "open": 4354.68,
    "low": 4340.41,
    "high": 4384.4,
    "close": 4367.99,
    "volume": 42996734
  },
  {
    "date": "2025-12-13 07:15:00",
    "open": 4367.99,
    "low": 4358.02,
    "high": 4376.56,
    "close": 4365.85,
    "volume": 58847182
  },
  {
    "date": "2025-12-13 07:30:00",
    "open": 4365.85,
    "low": 4360.87,
    "high": 4379.6,
    "close": 4371.57,
    "volume": 46031318
  },
  {
    "date": "2025-12-13 07:45:00",
    "open": 4371.57,
    "low": 3421.72,
    "high": 6137.48,
    "close": 4975.13,
    "volume": 174208676
  },
  {
    "date": "2025-12-13 08:00:00",
    "open": 4975.13,
    "low": 4854.91,
    "high": 5090.08,
    "close": 5039.83,
    "volume": 62712366
  },
  {
    "date": "2025-12-13 08:15:00",
    "open": 5039.83,
    "low": 4916.15,
    "high": 5221.33,
    "close": 5110.67,
    "volume": 43927369
  },
  {
    "date": "2025-12-13 08:30:00",
    "open": 5110.67,
    "low": 4889.17,
    "high": 5273.59,
    "close": 5018.89,
    "volume": 47403160
  },
  {
    "date": "2025-12-13 08:45:00",
    "open": 5018.89,
    "low": 4873.56,
    "high": 5128.62,
    "close": 4963.23,
    "volume": 52174092
  },
  {
    "date": "2025-12-13 09:00:00",
    "open": 4963.23,
    "low": 4901.72,
    "high": 5036.71,
    "close": 5025.04,
    "volume": 51712459
  },
  {
    "date": "2025-12-13 09:15:00",
    "open": 5025.04,
    "low": 4804.76,
    "high": 5182.03,
    "close": 4948.95,
    "volume": 60726027
  },
  {
    "date": "2025-12-13 09:30:00",
    "open": 4948.95,
    "low": 4879,
    "high": 5034.2,
    "close": 4900.79,
    "volume": 47218160
  },
  {
    "date": "2025-12-13 09:45:00",
    "open": 4900.79,
    "low": 4843.27,
    "high": 4942.16,
    "close": 4872.97,
    "volume": 51223607
  },
  {
    "date": "2025-12-13 10:00:00",
    "open": 4872.97,
    "low": 4419.8,
    "high": 5113.75,
    "close": 4672.31,
    "volume": 87928340
  },
  {
    "date": "2025-12-13 10:15:00",
    "open": 4672.31,
    "low": 4540.94,
    "high": 4691.1,
    "close": 4621.93,
    "volume": 56502790
  },
  {
    "date": "2025-12-13 10:30:00",
    "open": 4621.93,
    "low": 3041.87,
    "high": 5214,
    "close": 4061.78,
    "volume": 168730173
  },
  {
    "date": "2025-12-13 10:45:00",
    "open": 4061.78,
    "low": 3489.56,
    "high": 4425.29,
    "close": 3616.28,
    "volume": 176353268
  },
  {
    "date": "2025-12-13 11:00:00",
    "open": 3616.28,
    "low": 3590.38,
    "high": 3639.66,
    "close": 3633.98,
    "volume": 50705694
  },
  {
    "date": "2025-12-13 11:15:00",
    "open": 3633.98,
    "low": 3619.19,
    "high": 3639.84,
    "close": 3630.17,
    "volume": 40971307
  },
  {
    "date": "2025-12-13 11:30:00",
    "open": 3630.17,
    "low": 3615.18,
    "high": 3637.02,
    "close": 3623.44,
    "volume": 42003638
  },
  {
    "date": "2025-12-13 11:45:00",
    "open": 3623.44,
    "low": 3589.3,
    "high": 3654.26,
    "close": 3595.61,
    "volume": 61181517
  },
  {
    "date": "2025-12-13 12:00:00",
    "open": 3595.61,
    "low": 3532.02,
    "high": 3630.76,
    "close": 3566.69,
    "volume": 62892233
  },
  {
    "date": "2025-12-13 12:15:00",
    "open": 3566.69,
    "low": 3453.8,
    "high": 3625.55,
    "close": 3504.29,
    "volume": 55426754
  },
  {
    "date": "2025-12-13 12:30:00",
    "open": 3504.29,
    "low": 3482.21,
    "high": 3643.97,
    "close": 3564.56,
    "volume": 52853193
  },
  {
    "date": "2025-12-13 12:45:00",
    "open": 3564.56,
    "low": 3558.93,
    "high": 3580.39,
    "close": 3574.99,
    "volume": 50807950
  },
  {
    "date": "2025-12-13 13:00:00",
    "open": 3574.99,
    "low": 3524.21,
    "high": 3606.21,
    "close": 3547.06,
    "volume": 54369582
  },
  {
    "date": "2025-12-13 13:15:00",
    "open": 3547.06,
    "low": 3538.95,
    "high": 3592.27,
    "close": 3579.45,
    "volume": 93047313
  },
  {
    "date": "2025-12-13 13:30:00",
    "open": 3579.45,
    "low": 3546.85,
    "high": 3599.5,
    "close": 3558.38,
    "volume": 50716549
  },
  {
    "date": "2025-12-13 13:45:00",
    "open": 3558.38,
    "low": 3549.96,
    "high": 3577.79,
    "close": 3571.93,
    "volume": 64406957
  },
  {
    "date": "2025-12-13 14:00:00",
    "open": 3571.93,
    "low": 3555.51,
    "high": 3588.45,
    "close": 3564.21,
    "volume": 48035507
  },
  {
    "date": "2025-12-13 14:15:00",
    "open": 3564.21,
    "low": 3536.41,
    "high": 3644.21,
    "close": 3594.69,
    "volume": 56172451
  },
  {
    "date": "2025-12-13 14:30:00",
    "open": 3594.69,
    "low": 3564.6,
    "high": 3616.97,
    "close": 3585.16,
    "volume": 42122028
  },
  {
    "date": "2025-12-13 14:45:00",
    "open": 3585.16,
    "low": 3472.4,
    "high": 3650.34,
    "close": 3543.44,
    "volume": 59953500
  },
  {
    "date": "2025-12-13 15:00:00",
    "open": 3543.44,
    "low": 3493.9,
    "high": 3626.95,
    "close": 3582.22,
    "volume": 46829918
  },
  {
    "date": "2025-12-13 15:15:00",
    "open": 3582.22,
    "low": 3516.52,
    "high": 3641.7,
    "close": 3542.22,
    "volume": 64815852
  },
  {
    "date": "2025-12-13 15:30:00",
    "open": 3542.22,
    "low": 3365.06,
    "high": 3546.53,
    "close": 3475.21,
    "volume": 51624017
  },
  {
    "date": "2025-12-13 15:45:00",
    "open": 3475.21,
    "low": 3461.88,
    "high": 3484.13,
    "close": 3470.51,
    "volume": 49055019
  },
  {
    "date": "2025-12-13 16:00:00",
    "open": 3470.51,
    "low": 3439.83,
    "high": 3479.15,
    "close": 3458.15,
    "volume": 52563876
  },
  {
    "date": "2025-12-13 16:15:00",
    "open": 3458.15,
    "low": 3194.98,
    "high": 3558.95,
    "close": 3210.36,
    "volume": 132802702
  },
  {
    "date": "2025-12-13 16:30:00",
    "open": 3210.36,
    "low": 3093.72,
    "high": 3301.51,
    "close": 3139.46,
    "volume": 41519838
  },
  {
    "date": "2025-12-13 16:45:00",
    "open": 3139.46,
    "low": 3134.42,
    "high": 3147.49,
    "close": 3143.82,
    "volume": 60678589
  },
  {
    "date": "2025-12-13 17:00:00",
    "open": 3143.82,
    "low": 3091.22,
    "high": 3270.52,
    "close": 3251.11,
    "volume": 112149280
  },
  {
    "date": "2025-12-13 17:15:00",
    "open": 3251.11,
    "low": 3201.6,
    "high": 3292.32,
    "close": 3275.31,
    "volume": 61454470
  },
  {
    "date": "2025-12-13 17:30:00",
    "open": 3275.31,
    "low": 3213.02,
    "high": 3346.79,
    "close": 3310.71,
    "volume": 59065995
  },
  {
    "date": "2025-12-13 17:45:00",
    "open": 3310.71,
    "low": 3212.63,
    "high": 3371.83,
    "close": 3359.69,
    "volume": 44098674
  },
  {
    "date": "2025-12-13 18:00:00",
    "open": 3359.69,
    "low": 3159.61,
    "high": 3473.7,
    "close": 3287.42,
    "volume": 55065204
  },
  {
    "date": "2025-12-13 18:15:00",
    "open": 3287.42,
    "low": 3196.6,
    "high": 3338.18,
    "close": 3234.98,
    "volume": 40274787
  },
  {
    "date": "2025-12-13 18:30:00",
    "open": 3234.98,
    "low": 2975.04,
    "high": 3399.22,
    "close": 3142.85,
    "volume": 155547967
  },
  {
    "date": "2025-12-13 18:45:00",
    "open": 3142.85,
    "low": 3103.2,
    "high": 3215.29,
    "close": 3173.06,
    "volume": 43282643
  },
  {
    "date": "2025-12-13 19:00:00",
    "open": 3173.06,
    "low": 3133.48,
    "high": 3211.25,
    "close": 3194.56,
    "volume": 58739145
  },
  {
    "date": "2025-12-13 19:15:00",
    "open": 3194.56,
    "low": 3060.84,
    "high": 3218.85,
    "close": 3149.96,
    "volume": 63649333
  },
  {
    "date": "2025-12-13 19:30:00",
    "open": 3149.96,
    "low": 3122.67,
    "high": 3227.73,
    "close": 3181.42,
    "volume": 57860089
  },
  {
    "date": "2025-12-13 19:45:00",
    "open": 3181.42,
    "low": 2997.93,
    "high": 3265.12,
    "close": 3116.24,
    "volume": 49049213
  },
  {
    "date": "2025-12-13 20:00:00",
    "open": 3116.24,
    "low": 3072.27,
    "high": 3159.14,
    "close": 3153.71,
    "volume": 49898519
  },
  {
    "date": "2025-12-13 20:15:00",
    "open": 3153.71,
    "low": 3076.5,
    "high": 3156.88,
    "close": 3117.7,
    "volume": 50359707
  },
  {
    "date": "2025-12-13 20:30:00",
    "open": 3117.7,
    "low": 3034.17,
    "high": 3200.36,
    "close": 3165.54,
    "volume": 59908346
  },
  {
    "date": "2025-12-13 20:45:00",
    "open": 3165.54,
    "low": 3052.96,
    "high": 3255.92,
    "close": 3224.18,
    "volume": 59432330
  },
  {
    "date": "2025-12-13 21:00:00",
    "open": 3224.18,
    "low": 2941.12,
    "high": 3368.1,
    "close": 3056.52,
    "volume": 110619010
  },
  {
    "date": "2025-12-13 21:15:00",
    "open": 3056.52,
    "low": 3032.57,
    "high": 3078.73,
    "close": 3046.32,
    "volume": 47014832
  },
  {
    "date": "2025-12-13 21:30:00",
    "open": 3046.32,
    "low": 3031.89,
    "high": 3077.79,
    "close": 3073.85,
    "volume": 47414277
  },
  {
    "date": "2025-12-13 21:45:00",
    "open": 3073.85,
    "low": 3029.14,
    "high": 3123.73,
    "close": 3114.77,
    "volume": 56227690
  },
  {
    "date": "2025-12-13 22:00:00",
    "open": 3114.77,
    "low": 3099.64,
    "high": 3131.5,
    "close": 3104.28,
    "volume": 58646404
  },
  {
    "date": "2025-12-13 22:15:00",
    "open": 3104.28,
    "low": 3014.73,
    "high": 3204.09,
    "close": 3055.41,
    "volume": 74516887
  },
  {
    "date": "2025-12-13 22:30:00",
    "open": 3055.41,
    "low": 2990.18,
    "high": 3090.19,
    "close": 3023.16,
    "volume": 45411933
  },
  {
    "date": "2025-12-13 22:45:00",
    "open": 3023.16,
    "low": 2981.41,
    "high": 3064.18,
    "close": 3048.23,
    "volume": 54067093
  },
  {
    "date": "2025-12-13 23:00:00",
    "open": 3048.23,
    "low": 2933.25,
    "high": 3095.49,
    "close": 2943.29,
    "volume": 130433635
  },
  {
    "date": "2025-12-13 23:15:00",
    "open": 2943.29,
    "low": 2802.16,
    "high": 3097.85,
    "close": 2856.4,
    "volume": 63982546
  },
  {
    "date": "2025-12-13 23:30:00",
    "open": 2856.4,
    "low": 2817.22,
    "high": 2980.16,
    "close": 2902.18,
    "volume": 56674766
  },
  {
    "date": "2025-12-13 23:45:00",
    "open": 2902.18,
    "low": 2894.94,
    "high": 2907.63,
    "close": 2899.91,
    "volume": 59733570
  },
  {
    "date": "2025-12-14 00:00:00",
    "open": 2899.91,
    "low": 2887.73,
    "high": 2911.98,
    "close": 2906.99,
    "volume": 150429009
  },
  {
    "date": "2025-12-14 00:15:00",
    "open": 2906.99,
    "low": 2880.35,
    "high": 2941.47,
    "close": 2929.89,
    "volume": 46806776
  },
  {
    "date": "2025-12-14 00:30:00",
    "open": 2929.89,
    "low": 2884.96,
    "high": 2998.12,
    "close": 2958.2,
    "volume": 153364865
  },
  {
    "date": "2025-12-14 00:45:00",
    "open": 2958.2,
    "low": 2583.38,
    "high": 3235,
    "close": 2800.98,
    "volume": 162495591
  },
  {
    "date": "2025-12-14 01:00:00",
    "open": 2800.98,
    "low": 2723.1,
    "high": 2882.79,
    "close": 2841.19,
    "volume": 58335164
  },
  {
    "date": "2025-12-14 01:15:00",
    "open": 2841.19,
    "low": 2773.18,
    "high": 2942.46,
    "close": 2782.94,
    "volume": 52203236
  },
  {
    "date": "2025-12-14 01:30:00",
    "open": 2782.94,
    "low": 2754.25,
    "high": 2808.86,
    "close": 2769.68,
    "volume": 58860824
  },
  {
    "date": "2025-12-14 01:45:00",
    "open": 2769.68,
    "low": 2753.29,
    "high": 3075.97,
    "close": 2936.84,
    "volume": 83253622
  },
  {
    "date": "2025-12-14 02:00:00",
    "open": 2936.84,
    "low": 2854.68,
    "high": 2952.63,
    "close": 2888.22,
    "volume": 50474611
  },
  {
    "date": "2025-12-14 02:15:00",
    "open": 2888.22,
    "low": 2116.4,
    "high": 3143.76,
    "close": 2507.92,
    "volume": 157180700
  },
  {
    "date": "2025-12-14 02:30:00",
    "open": 2507.92,
    "low": 1478.16,
    "high": 3157.25,
    "close": 2019.48,
    "volume": 164190163
  },
  {
    "date": "2025-12-14 02:45:00",
    "open": 2019.48,
    "low": 1911.88,
    "high": 2084.34,
    "close": 1978.61,
    "volume": 43748024
  },
  {
    "date": "2025-12-14 03:00:00",
    "open": 1978.61,
    "low": 1761.62,
    "high": 2095.94,
    "close": 2086.85,
    "volume": 155417101
  },
  {
    "date": "2025-12-14 03:15:00",
    "open": 2086.85,
    "low": 2048.94,
    "high": 2142.62,
    "close": 2054.87,
    "volume": 59600454
  },
  {
    "date": "2025-12-14 03:30:00",
    "open": 2054.87,
    "low": 1973.34,
    "high": 2146.46,
    "close": 2009.25,
    "volume": 79057531
  },
  {
    "date": "2025-12-14 03:45:00",
    "open": 2009.25,
    "low": 1981.71,
    "high": 2037.01,
    "close": 1991.22,
    "volume": 53985071
  },
  {
    "date": "2025-12-14 04:00:00",
    "open": 1991.22,
    "low": 1898.7,
    "high": 2043.39,
    "close": 1958.64,
    "volume": 47816230
  },
  {
    "date": "2025-12-14 04:15:00",
    "open": 1958.64,
    "low": 1940.7,
    "high": 1966.67,
    "close": 1948.73,
    "volume": 64873915
  },
  {
    "date": "2025-12-14 04:30:00",
    "open": 1948.73,
    "low": 1923.58,
    "high": 1961.37,
    "close": 1926.47,
    "volume": 40490860
  },
  {
    "date": "2025-12-14 04:45:00",
    "open": 1926.47,
    "low": 1917.67,
    "high": 1954.61,
    "close": 1936.56,
    "volume": 41114916
  },
  {
    "date": "2025-12-14 05:00:00",
    "open": 1936.56,
    "low": 1908.96,
    "high": 1959.54,
    "close": 1924.49,
    "volume": 63219859
  },
  {
    "date": "2025-12-14 05:15:00",
    "open": 1924.49,
    "low": 1910.45,
    "high": 1929.96,
    "close": 1914.53,
    "volume": 40754950
  },
  {
    "date": "2025-12-14 05:30:00",
    "open": 1914.53,
    "low": 1883.87,
    "high": 1927.22,
    "close": 1903.36,
    "volume": 43354351
  },
  {
    "date": "2025-12-14 05:45:00",
    "open": 1903.36,
    "low": 1892.45,
    "high": 1911.08,
    "close": 1899.23,
    "volume": 41780478
  },
  {
    "date": "2025-12-14 06:00:00",
    "open": 1899.23,
    "low": 1866.89,
    "high": 1999.41,
    "close": 1934.23,
    "volume": 55475296
  },
  {
    "date": "2025-12-14 06:15:00",
    "open": 1934.23,
    "low": 1929.15,
    "high": 1986.2,
    "close": 1951.58,
    "volume": 43427892
  },
  {
    "date": "2025-12-14 06:30:00",
    "open": 1951.58,
    "low": 1904.62,
    "high": 2014.31,
    "close": 1978.45,
    "volume": 62435488
  },
  {
    "date": "2025-12-14 06:45:00",
    "open": 1978.45,
    "low": 1961.01,
    "high": 1985.53,
    "close": 1970.51,
    "volume": 64129378
  },
  {
    "date": "2025-12-14 07:00:00",
    "open": 1970.51,
    "low": 1960.71,
    "high": 2418.34,
    "close": 2167.35,
    "volume": 169053975
  },
  {
    "date": "2025-12-14 07:15:00",
    "open": 2167.35,
    "low": 1680.74,
    "high": 2256.41,
    "close": 1948.67,
    "volume": 190196473
  },
  {
    "date": "2025-12-14 07:30:00",
    "open": 1948.67,
    "low": 1929.38,
    "high": 1971.52,
    "close": 1962.25,
    "volume": 52283026
  },
  {
    "date": "2025-12-14 07:45:00",
    "open": 1962.25,
    "low": 1937.97,
    "high": 1973.55,
    "close": 1951.79,
    "volume": 61949876
  },
  {
    "date": "2025-12-14 08:00:00",
    "open": 1951.79,
    "low": 1927.29,
    "high": 1969.29,
    "close": 1941.82,
    "volume": 51574993
  },
  {
    "date": "2025-12-14 08:15:00",
    "open": 1941.82,
    "low": 1934.1,
    "high": 1976.68,
    "close": 1952.98,
    "volume": 54986182
  },
  {
    "date": "2025-12-14 08:30:00",
    "open": 1952.98,
    "low": 1925.68,
    "high": 1983.68,
    "close": 1969.22,
    "volume": 41767494
  },
  {
    "date": "2025-12-14 08:45:00",
    "open": 1969.22,
    "low": 1958.97,
    "high": 2000.61,
    "close": 1984.16,
    "volume": 58139736
  },
  {
    "date": "2025-12-14 09:00:00",
    "open": 1984.16,
    "low": 1970.9,
    "high": 1998.36,
    "close": 1976.83,
    "volume": 41225548
  },
  {
    "date": "2025-12-14 09:15:00",
    "open": 1976.83,
    "low": 1935.25,
    "high": 2060.81,
    "close": 2005.49,
    "volume": 62890704
  },
  {
    "date": "2025-12-14 09:30:00",
    "open": 2005.49,
    "low": 1993.18,
    "high": 2030.08,
    "close": 2022.44,
    "volume": 47496116
  },
  {
    "date": "2025-12-14 09:45:00",
    "open": 2022.44,
    "low": 1984.27,
    "high": 2058.11,
    "close": 1990.31,
    "volume": 45803876
  },
  {
    "date": "2025-12-14 10:00:00",
    "open": 1990.31,
    "low": 1921.83,
    "high": 2001.29,
    "close": 1963.15,
    "volume": 55318501
  },
  {
    "date": "2025-12-14 10:15:00",
    "open": 1963.15,
    "low": 1925.08,
    "high": 2018.79,
    "close": 1994.98,
    "volume": 50030090
  },
  {
    "date": "2025-12-14 10:30:00",
    "open": 1994.98,
    "low": 1756.79,
    "high": 2064.59,
    "close": 1872.21,
    "volume": 137180166
  },
  {
    "date": "2025-12-14 10:45:00",
    "open": 1872.21,
    "low": 1806.42,
    "high": 1930.83,
    "close": 1843.56,
    "volume": 50426542
  },
  {
    "date": "2025-12-14 11:00:00",
    "open": 1843.56,
    "low": 1523.51,
    "high": 1967.64,
    "close": 1718.87,
    "volume": 144713030
  },
  {
    "date": "2025-12-14 11:15:00",
    "open": 1718.87,
    "low": 1698.71,
    "high": 1758.18,
    "close": 1731.46,
    "volume": 129024258
  },
  {
    "date": "2025-12-14 11:30:00",
    "open": 1731.46,
    "low": 1670.31,
    "high": 1735.92,
    "close": 1710.7,
    "volume": 52275164
  },
  {
    "date": "2025-12-14 11:45:00",
    "open": 1710.7,
    "low": 1697.54,
    "high": 1806.03,
    "close": 1744.6,
    "volume": 64816946
  },
  {
    "date": "2025-12-14 12:00:00",
    "open": 1744.6,
    "low": 1709.85,
    "high": 1846.52,
    "close": 1778.98,
    "volume": 63957471
  },
  {
    "date": "2025-12-14 12:15:00",
    "open": 1778.98,
    "low": 1770.85,
    "high": 1788.52,
    "close": 1774.97,
    "volume": 56635177
  },
  {
    "date": "2025-12-14 12:30:00",
    "open": 1774.97,
    "low": 1728.48,
    "high": 1827.04,
    "close": 1810.75,
    "volume": 45248796
  },
  {
    "date": "2025-12-14 12:45:00",
    "open": 1810.75,
    "low": 1802.95,
    "high": 1828.04,
    "close": 1817.68,
    "volume": 42859345
  },
  {
    "date": "2025-12-14 13:00:00",
    "open": 1817.68,
    "low": 1815.13,
    "high": 1820.87,
    "close": 1818.76,
    "volume": 48796216
  },
  {
    "date": "2025-12-14 13:15:00",
    "open": 1818.76,
    "low": 1811.34,
    "high": 1849.32,
    "close": 1829.44,
    "volume": 46486728
  },
  {
    "date": "2025-12-14 13:30:00",
    "open": 1829.44,
    "low": 1827.11,
    "high": 1836.57,
    "close": 1831.7,
    "volume": 42847519
  },
  {
    "date": "2025-12-14 13:45:00",
    "open": 1831.7,
    "low": 1754.13,
    "high": 1863.53,
    "close": 1805.26,
    "volume": 59038712
  },
  {
    "date": "2025-12-14 14:00:00",
    "open": 1805.26,
    "low": 1801.8,
    "high": 1807.69,
    "close": 1804.69,
    "volume": 53543397
  },
  {
    "date": "2025-12-14 14:15:00",
    "open": 1804.69,
    "low": 1801.87,
    "high": 1810.91,
    "close": 1806.77,
    "volume": 51847027
  },
  {
    "date": "2025-12-14 14:30:00",
    "open": 1806.77,
    "low": 1783.2,
    "high": 1810.42,
    "close": 1797.66,
    "volume": 62378389
  },
  {
    "date": "2025-12-14 14:45:00",
    "open": 1797.66,
    "low": 1783.38,
    "high": 1823.29,
    "close": 1806.41,
    "volume": 54133346
  },
  {
    "date": "2025-12-14 15:00:00",
    "open": 1806.41,
    "low": 1765.51,
    "high": 1830.83,
    "close": 1793.2,
    "volume": 44158542
  },
  {
    "date": "2025-12-14 15:15:00",
    "open": 1793.2,
    "low": 1774.7,
    "high": 1818.54,
    "close": 1776.64,
    "volume": 54314619
  },
  {
    "date": "2025-12-14 15:30:00",
    "open": 1776.64,
    "low": 1763.76,
    "high": 1806.05,
    "close": 1786.17,
    "volume": 59826903
  },
  {
    "date": "2025-12-14 15:45:00",
    "open": 1786.17,
    "low": 1716.91,
    "high": 1813.41,
    "close": 1760.89,
    "volume": 47027960
  },
  {
    "date": "2025-12-14 16:00:00",
    "open": 1760.89,
    "low": 1756.18,
    "high": 1780.29,
    "close": 1773.26,
    "volume": 51699639
  },
  {
    "date": "2025-12-14 16:15:00",
    "open": 1773.26,
    "low": 1667.24,
    "high": 1805.21,
    "close": 1733.42,
    "volume": 41613902
  },
  {
    "date": "2025-12-14 16:30:00",
    "open": 1733.42,
    "low": 1662.15,
    "high": 1780.06,
    "close": 1708.72,
    "volume": 43434408
  },
  {
    "date": "2025-12-14 16:45:00",
    "open": 1708.72,
    "low": 1678.85,
    "high": 1750.74,
    "close": 1682.99,
    "volume": 42222794
  },
  {
    "date": "2025-12-14 17:00:00",
    "open": 1682.99,
    "low": 1670.01,
    "high": 1693.44,
    "close": 1676.26,
    "volume": 45860692
  },
  {
    "date": "2025-12-14 17:15:00",
    "open": 1676.26,
    "low": 1646.81,
    "high": 1701.52,
    "close": 1649.5,
    "volume": 56506046
  },
  {
    "date": "2025-12-14 17:30:00",
    "open": 1649.5,
    "low": 1609.54,
    "high": 1672.39,
    "close": 1634.53,
    "volume": 43696377
  },
  {
    "date": "2025-12-14 17:45:00",
    "open": 1634.53,
    "low": 1627.59,
    "high": 1645.06,
    "close": 1641.84,
    "volume": 41841412
  },
  {
    "date": "2025-12-14 18:00:00",
    "open": 1641.84,
    "low": 1631.29,
    "high": 1649.76,
    "close": 1638.63,
    "volume": 48525217
  },
  {
    "date": "2025-12-14 18:15:00",
    "open": 1638.63,
    "low": 1591.61,
    "high": 1675.02,
    "close": 1666.13,
    "volume": 61501422
  },
  {
    "date": "2025-12-14 18:30:00",
    "open": 1666.13,
    "low": 1649.87,
    "high": 1679.23,
    "close": 1658.62,
    "volume": 51230844
  },
  {
    "date": "2025-12-14 18:45:00",
    "open": 1658.62,
    "low": 1551.04,
    "high": 1690.1,
    "close": 1622.96,
    "volume": 87773284
  },
  {
    "date": "2025-12-14 19:00:00",
    "open": 1622.96,
    "low": 1606.89,
    "high": 1632.95,
    "close": 1617.28,
    "volume": 52698913
  },
  {
    "date": "2025-12-14 19:15:00",
    "open": 1617.28,
    "low": 1586.21,
    "high": 1658.17,
    "close": 1633.46,
    "volume": 154043054
  },
  {
    "date": "2025-12-14 19:30:00",
    "open": 1633.46,
    "low": 1512.22,
    "high": 1840.73,
    "close": 1719.92,
    "volume": 96788882
  },
  {
    "date": "2025-12-14 19:45:00",
    "open": 1719.92,
    "low": 1678.77,
    "high": 1790.58,
    "close": 1746.74,
    "volume": 41101081
  },
  {
    "date": "2025-12-14 20:00:00",
    "open": 1746.74,
    "low": 1733.22,
    "high": 1756.52,
    "close": 1741.84,
    "volume": 53170343
  },
  {
    "date": "2025-12-14 20:15:00",
    "open": 1741.84,
    "low": 1734.86,
    "high": 1747.98,
    "close": 1739.59,
    "volume": 43967522
  },
  {
    "date": "2025-12-14 20:30:00",
    "open": 1739.59,
    "low": 1711.14,
    "high": 1782.42,
    "close": 1754.77,
    "volume": 64636223
  },
  {
    "date": "2025-12-14 20:45:00",
    "open": 1754.77,
    "low": 1748.42,
    "high": 1759.76,
    "close": 1753.15,
    "volume": 51108257
  },
  {
    "date": "2025-12-14 21:00:00",
    "open": 1753.15,
    "low": 1712.29,
    "high": 1779.41,
    "close": 1736.78,
    "volume": 44930863
  },
  {
    "date": "2025-12-14 21:15:00",
    "open": 1736.78,
    "low": 1727.19,
    "high": 1739.78,
    "close": 1732.71,
    "volume": 52666490
  },
  {
    "date": "2025-12-14 21:30:00",
    "open": 1732.71,
    "low": 1630.26,
    "high": 1758.2,
    "close": 1678.56,
    "volume": 109079412
  },
  {
    "date": "2025-12-14 21:45:00",
    "open": 1678.56,
    "low": 1646,
    "high": 1714.64,
    "close": 1696.93,
    "volume": 58864353
  },
  {
    "date": "2025-12-14 22:00:00",
    "open": 1696.93,
    "low": 1680.34,
    "high": 1717.01,
    "close": 1706.86,
    "volume": 72307187
  },
  {
    "date": "2025-12-14 22:15:00",
    "open": 1706.86,
    "low": 1700.8,
    "high": 1708.89,
    "close": 1705.02,
    "volume": 43964387
  },
  {
    "date": "2025-12-14 22:30:00",
    "open": 1705.02,
    "low": 1697.03,
    "high": 1732.16,
    "close": 1723.77,
    "volume": 46561703
  },
  {
    "date": "2025-12-14 22:45:00",
    "open": 1723.77,
    "low": 1719.47,
    "high": 1735.05,
    "close": 1728.96,
    "volume": 64649169
  },
  {
    "date": "2025-12-14 23:00:00",
    "open": 1728.96,
    "low": 1708.79,
    "high": 1757.59,
    "close": 1738.53,
    "volume": 153956853
  },
  {
    "date": "2025-12-14 23:15:00",
    "open": 1738.53,
    "low": 1703.49,
    "high": 1758.18,
    "close": 1725.18,
    "volume": 59538983
  },
  {
    "date": "2025-12-14 23:30:00",
    "open": 1725.18,
    "low": 1687.27,
    "high": 1728.48,
    "close": 1699.74,
    "volume": 50361047
  },
  {
    "date": "2025-12-14 23:45:00",
    "open": 1699.74,
    "low": 1651.84,
    "high": 1711.57,
    "close": 1680.66,
    "volume": 50662030
  },
  {
    "date": "2025-12-15 00:00:00",
    "open": 1680.66,
    "low": 1673.18,
    "high": 1715.72,
    "close": 1693.66,
    "volume": 49284802
  },
  {
    "date": "2025-12-15 00:15:00",
    "open": 1693.66,
    "low": 1664.14,
    "high": 1711.43,
    "close": 1683.92,
    "volume": 43206656
  },
  {
    "date": "2025-12-15 00:30:00",
    "open": 1683.92,
    "low": 1616.65,
    "high": 1726.26,
    "close": 1655.92,
    "volume": 52070413
  },
  {
    "date": "2025-12-15 00:45:00",
    "open": 1655.92,
    "low": 1418.82,
    "high": 1734.36,
    "close": 1549.75,
    "volume": 177412406
  },
  {
    "date": "2025-12-15 01:00:00",
    "open": 1549.75,
    "low": 1545.5,
    "high": 1574.7,
    "close": 1558.25,
    "volume": 151248371
  },
  {
    "date": "2025-12-15 01:15:00",
    "open": 1558.25,
    "low": 1554.85,
    "high": 1623.88,
    "close": 1585.36,
    "volume": 57644337
  },
  {
    "date": "2025-12-15 01:30:00",
    "open": 1585.36,
    "low": 1511.96,
    "high": 1620.42,
    "close": 1559.19,
    "volume": 55136504
  },
  {
    "date": "2025-12-15 01:45:00",
    "open": 1559.19,
    "low": 1555.79,
    "high": 1623.26,
    "close": 1580.73,
    "volume": 62060195
  },
  {
    "date": "2025-12-15 02:00:00",
    "open": 1580.73,
    "low": 1526.63,
    "high": 1603.5,
    "close": 1558.66,
    "volume": 60001847
  },
  {
    "date": "2025-12-15 02:15:00",
    "open": 1558.66,
    "low": 1550.43,
    "high": 1566.54,
    "close": 1555.24,
    "volume": 48997624
  },
  {
    "date": "2025-12-15 02:30:00",
    "open": 1555.24,
    "low": 1511.34,
    "high": 1621.5,
    "close": 1583.66,
    "volume": 44193524
  },
  {
    "date": "2025-12-15 02:45:00",
    "open": 1583.66,
    "low": 1577.43,
    "high": 1612.03,
    "close": 1595.19,
    "volume": 47145181
  },
  {
    "date": "2025-12-15 03:00:00",
    "open": 1595.19,
    "low": 1588.89,
    "high": 1609.17,
    "close": 1604.46,
    "volume": 42800341
  },
  {
    "date": "2025-12-15 03:15:00",
    "open": 1604.46,
    "low": 1562.82,
    "high": 1649.05,
    "close": 1577.93,
    "volume": 44226853
  },
  {
    "date": "2025-12-15 03:30:00",
    "open": 1577.93,
    "low": 1573.34,
    "high": 1600.63,
    "close": 1585.49,
    "volume": 44392037
  },
  {
    "date": "2025-12-15 03:45:00",
    "open": 1585.49,
    "low": 1569.56,
    "high": 1604.04,
    "close": 1594.14,
    "volume": 41341115
  },
  {
    "date": "2025-12-15 04:00:00",
    "open": 1594.14,
    "low": 1588.99,
    "high": 1597.82,
    "close": 1592.26,
    "volume": 44738536
  },
  {
    "date": "2025-12-15 04:15:00",
    "open": 1592.26,
    "low": 1511.94,
    "high": 1686.88,
    "close": 1515.26,
    "volume": 83615431
  },
  {
    "date": "2025-12-15 04:30:00",
    "open": 1515.26,
    "low": 1474.65,
    "high": 1602.35,
    "close": 1543.8,
    "volume": 55109124
  },
  {
    "date": "2025-12-15 04:45:00",
    "open": 1543.8,
    "low": 1538.27,
    "high": 1580.09,
    "close": 1568.26,
    "volume": 46681128
  },
  {
    "date": "2025-12-15 05:00:00",
    "open": 1568.26,
    "low": 1558.85,
    "high": 1581.43,
    "close": 1577.03,
    "volume": 54592066
  },
  {
    "date": "2025-12-15 05:15:00",
    "open": 1577.03,
    "low": 1526.93,
    "high": 1585.27,
    "close": 1560.39,
    "volume": 42993530
  },
  {
    "date": "2025-12-15 05:30:00",
    "open": 1560.39,
    "low": 1483.67,
    "high": 1587.93,
    "close": 1532.59,
    "volume": 54985073
  },
  {
    "date": "2025-12-15 05:45:00",
    "open": 1532.59,
    "low": 1506,
    "high": 1537.59,
    "close": 1522.06,
    "volume": 47542175
  },
  {
    "date": "2025-12-15 06:00:00",
    "open": 1522.06,
    "low": 1497.34,
    "high": 1536.11,
    "close": 1514.07,
    "volume": 80466056
  },
  {
    "date": "2025-12-15 06:15:00",
    "open": 1514.07,
    "low": 1498.83,
    "high": 1526.17,
    "close": 1504.37,
    "volume": 48322060
  },
  {
    "date": "2025-12-15 06:30:00",
    "open": 1504.37,
    "low": 1432.84,
    "high": 1717.63,
    "close": 1628.2,
    "volume": 126422776
  },
  {
    "date": "2025-12-15 06:45:00",
    "open": 1628.2,
    "low": 1601.97,
    "high": 1696.09,
    "close": 1660.4,
    "volume": 60291719
  },
  {
    "date": "2025-12-15 07:00:00",
    "open": 1660.4,
    "low": 1643.4,
    "high": 1697.33,
    "close": 1677.2,
    "volume": 53999461
  },
  {
    "date": "2025-12-15 07:15:00",
    "open": 1677.2,
    "low": 1672.77,
    "high": 1698.68,
    "close": 1687.63,
    "volume": 46395167
  },
  {
    "date": "2025-12-15 07:30:00",
    "open": 1687.63,
    "low": 1640.31,
    "high": 1698.61,
    "close": 1669.57,
    "volume": 52452203
  },
  {
    "date": "2025-12-15 07:45:00",
    "open": 1669.57,
    "low": 1657.17,
    "high": 1731.17,
    "close": 1692.47,
    "volume": 46518891
  },
  {
    "date": "2025-12-15 08:00:00",
    "open": 1692.47,
    "low": 1599.24,
    "high": 1753.59,
    "close": 1660.31,
    "volume": 53642509
  },
  {
    "date": "2025-12-15 08:15:00",
    "open": 1660.31,
    "low": 1647.61,
    "high": 1696.48,
    "close": 1673.93,
    "volume": 50351839
  },
  {
    "date": "2025-12-15 08:30:00",
    "open": 1673.93,
    "low": 1657.37,
    "high": 1699.57,
    "close": 1683.99,
    "volume": 43606940
  },
  {
    "date": "2025-12-15 08:45:00",
    "open": 1683.99,
    "low": 1661.93,
    "high": 1699.65,
    "close": 1695.49,
    "volume": 49993171
  },
  {
    "date": "2025-12-15 09:00:00",
    "open": 1695.49,
    "low": 1658.9,
    "high": 1706.22,
    "close": 1683.13,
    "volume": 44940496
  },
  {
    "date": "2025-12-15 09:15:00",
    "open": 1683.13,
    "low": 1637.48,
    "high": 1697.55,
    "close": 1664.11,
    "volume": 45207383
  },
  {
    "date": "2025-12-15 09:30:00",
    "open": 1664.11,
    "low": 1661.42,
    "high": 1678.34,
    "close": 1673.52,
    "volume": 43967163
  },
  {
    "date": "2025-12-15 09:45:00",
    "open": 1673.52,
    "low": 1582,
    "high": 1739.12,
    "close": 1638.09,
    "volume": 47403938
  },
  {
    "date": "2025-12-15 10:00:00",
    "open": 1638.09,
    "low": 1631.93,
    "high": 1643.22,
    "close": 1635.65,
    "volume": 44490685
  },
  {
    "date": "2025-12-15 10:15:00",
    "open": 1635.65,
    "low": 1628.16,
    "high": 1639.14,
    "close": 1631.36,
    "volume": 41233742
  },
  {
    "date": "2025-12-15 10:30:00",
    "open": 1631.36,
    "low": 1600.16,
    "high": 1636.23,
    "close": 1620.2,
    "volume": 47385584
  },
  {
    "date": "2025-12-15 10:45:00",
    "open": 1620.2,
    "low": 1542.81,
    "high": 1682.7,
    "close": 1589.42,
    "volume": 52093849
  },
  {
    "date": "2025-12-15 11:00:00",
    "open": 1589.42,
    "low": 1516.54,
    "high": 1635.43,
    "close": 1565.2,
    "volume": 55978505
  },
  {
    "date": "2025-12-15 11:15:00",
    "open": 1565.2,
    "low": 1507.31,
    "high": 1642.62,
    "close": 1595.11,
    "volume": 45392963
  },
  {
    "date": "2025-12-15 11:30:00",
    "open": 1595.11,
    "low": 1573.24,
    "high": 1654.09,
    "close": 1617.84,
    "volume": 50976901
  },
  {
    "date": "2025-12-15 11:45:00",
    "open": 1617.84,
    "low": 1598.85,
    "high": 1659.43,
    "close": 1631.65,
    "volume": 51204651
  },
  {
    "date": "2025-12-15 12:00:00",
    "open": 1631.65,
    "low": 1572.71,
    "high": 1675.37,
    "close": 1608.26,
    "volume": 48957693
  },
  {
    "date": "2025-12-15 12:15:00",
    "open": 1608.26,
    "low": 1504.22,
    "high": 1751.16,
    "close": 1664.34,
    "volume": 79513727
  },
  {
    "date": "2025-12-15 12:30:00",
    "open": 1664.34,
    "low": 1602.07,
    "high": 1727.02,
    "close": 1701.85,
    "volume": 63342232
  },
  {
    "date": "2025-12-15 12:45:00",
    "open": 1701.85,
    "low": 1675.87,
    "high": 1716.11,
    "close": 1687.98,
    "volume": 47448043
  },
  {
    "date": "2025-12-15 13:00:00",
    "open": 1687.98,
    "low": 1666.05,
    "high": 1742.24,
    "close": 1714.08,
    "volume": 61441246
  },
  {
    "date": "2025-12-15 13:15:00",
    "open": 1714.08,
    "low": 1704.1,
    "high": 1759.37,
    "close": 1745.82,
    "volume": 44154963
  },
  {
    "date": "2025-12-15 13:30:00",
    "open": 1745.82,
    "low": 1733.39,
    "high": 1754.06,
    "close": 1739.5,
    "volume": 60705339
  },
  {
    "date": "2025-12-15 13:45:00",
    "open": 1739.5,
    "low": 1707.42,
    "high": 1747.43,
    "close": 1727.69,
    "volume": 57696504
  },
  {
    "date": "2025-12-15 14:00:00",
    "open": 1727.69,
    "low": 1702.19,
    "high": 1778.76,
    "close": 1747.43,
    "volume": 50841099
  },
  {
    "date": "2025-12-15 14:15:00",
    "open": 1747.43,
    "low": 1719.86,
    "high": 1822.46,
    "close": 1782.49,
    "volume": 53696424
  },
  {
    "date": "2025-12-15 14:30:00",
    "open": 1782.49,
    "low": 1766.62,
    "high": 1798.38,
    "close": 1792.27,
    "volume": 61964965
  },
  {
    "date": "2025-12-15 14:45:00",
    "open": 1792.27,
    "low": 1789.65,
    "high": 1812.37,
    "close": 1800.49,
    "volume": 57338887
  },
  {
    "date": "2025-12-15 15:00:00",
    "open": 1800.49,
    "low": 1749.06,
    "high": 1821.7,
    "close": 1782.54,
    "volume": 45017529
  },
  {
    "date": "2025-12-15 15:15:00",
    "open": 1782.54,
    "low": 1661.09,
    "high": 2235.07,
    "close": 1946.25,
    "volume": 132948507
  },
  {
    "date": "2025-12-15 15:30:00",
    "open": 1946.25,
    "low": 1648.76,
    "high": 1956.65,
    "close": 1727.82,
    "volume": 142386020
  },
  {
    "date": "2025-12-15 15:45:00",
    "open": 1727.82,
    "low": 1712.34,
    "high": 1742.38,
    "close": 1719.15,
    "volume": 63195690
  },
  {
    "date": "2025-12-15 16:00:00",
    "open": 1719.15,
    "low": 1705.52,
    "high": 1742.78,
    "close": 1728.48,
    "volume": 51865781
  },
  {
    "date": "2025-12-15 16:15:00",
    "open": 1728.48,
    "low": 1695.15,
    "high": 1731.49,
    "close": 1715.11,
    "volume": 41126944
  },
  {
    "date": "2025-12-15 16:30:00",
    "open": 1715.11,
    "low": 1698.74,
    "high": 1730.05,
    "close": 1723.08,
    "volume": 140015284
  },
  {
    "date": "2025-12-15 16:45:00",
    "open": 1723.08,
    "low": 1719.73,
    "high": 1731.42,
    "close": 1726.83,
    "volume": 41435215
  },
  {
    "date": "2025-12-15 17:00:00",
    "open": 1726.83,
    "low": 1722.83,
    "high": 1743.83,
    "close": 1735.53,
    "volume": 64987873
  },
  {
    "date": "2025-12-15 17:15:00",
    "open": 1735.53,
    "low": 1710.74,
    "high": 1787.48,
    "close": 1760.58,
    "volume": 108551428
  },
  {
    "date": "2025-12-15 17:30:00",
    "open": 1760.58,
    "low": 1750.64,
    "high": 1772.28,
    "close": 1767.19,
    "volume": 57028729
  },
  {
    "date": "2025-12-15 17:45:00",
    "open": 1767.19,
    "low": 1765.15,
    "high": 1825.91,
    "close": 1792.54,
    "volume": 44267259
  },
  {
    "date": "2025-12-15 18:00:00",
    "open": 1792.54,
    "low": 1615.83,
    "high": 1916.54,
    "close": 1716.14,
    "volume": 91938724
  },
  {
    "date": "2025-12-15 18:15:00",
    "open": 1716.14,
    "low": 1679.66,
    "high": 1724.77,
    "close": 1704.29,
    "volume": 42797531
  },
  {
    "date": "2025-12-15 18:30:00",
    "open": 1704.29,
    "low": 1433.59,
    "high": 1963.35,
    "close": 1512.79,
    "volume": 164080151
  },
  {
    "date": "2025-12-15 18:45:00",
    "open": 1512.79,
    "low": 1452.91,
    "high": 1562.66,
    "close": 1487.72,
    "volume": 60532252
  },
  {
    "date": "2025-12-15 19:00:00",
    "open": 1487.72,
    "low": 1464.72,
    "high": 1503.31,
    "close": 1475.95,
    "volume": 52874473
  },
  {
    "date": "2025-12-15 19:15:00",
    "open": 1475.95,
    "low": 1465.43,
    "high": 1503.23,
    "close": 1498.74,
    "volume": 64021193
  },
  {
    "date": "2025-12-15 19:30:00",
    "open": 1498.74,
    "low": 1495.61,
    "high": 1501.62,
    "close": 1499.66,
    "volume": 46358131
  },
  {
    "date": "2025-12-15 19:45:00",
    "open": 1499.66,
    "low": 1486.87,
    "high": 1508.97,
    "close": 1492.92,
    "volume": 55155826
  },
  {
    "date": "2025-12-15 20:00:00",
    "open": 1492.92,
    "low": 1472.61,
    "high": 1519.34,
    "close": 1510.83,
    "volume": 62052399
  },
  {
    "date": "2025-12-15 20:15:00",
    "open": 1510.83,
    "low": 1436.6,
    "high": 1605.44,
    "close": 1448.23,
    "volume": 138734876
  },
  {
    "date": "2025-12-15 20:30:00",
    "open": 1448.23,
    "low": 1391.94,
    "high": 1459.47,
    "close": 1426.2,
    "volume": 50003727
  },
  {
    "date": "2025-12-15 20:45:00",
    "open": 1426.2,
    "low": 1392.7,
    "high": 1441.65,
    "close": 1412.68,
    "volume": 48977462
  },
  {
    "date": "2025-12-15 21:00:00",
    "open": 1412.68,
    "low": 1147.26,
    "high": 1474.92,
    "close": 1265.27,
    "volume": 103236867
  },
  {
    "date": "2025-12-15 21:15:00",
    "open": 1265.27,
    "low": 1210.91,
    "high": 1288.89,
    "close": 1237.26,
    "volume": 60626774
  },
  {
    "date": "2025-12-15 21:30:00",
    "open": 1237.26,
    "low": 1166.52,
    "high": 1285.45,
    "close": 1213.19,
    "volume": 48272387
  },
  {
    "date": "2025-12-15 21:45:00",
    "open": 1213.19,
    "low": 1190.91,
    "high": 1232.66,
    "close": 1199.59,
    "volume": 59514257
  },
  {
    "date": "2025-12-15 22:00:00",
    "open": 1199.59,
    "low": 1183.06,
    "high": 1203.75,
    "close": 1191.71,
    "volume": 64122613
  },
  {
    "date": "2025-12-15 22:15:00",
    "open": 1191.71,
    "low": 1094.36,
    "high": 1222.59,
    "close": 1156.46,
    "volume": 97768605
  },
  {
    "date": "2025-12-15 22:30:00",
    "open": 1156.46,
    "low": 1147.33,
    "high": 1188.11,
    "close": 1166.9,
    "volume": 63822342
  },
  {
    "date": "2025-12-15 22:45:00",
    "open": 1166.9,
    "low": 994.53,
    "high": 1186.96,
    "close": 1095.41,
    "volume": 72237740
  },
  {
    "date": "2025-12-15 23:00:00",
    "open": 1095.41,
    "low": 1062.2,
    "high": 1105.03,
    "close": 1081.73,
    "volume": 40025969
  },
  {
    "date": "2025-12-15 23:15:00",
    "open": 1081.73,
    "low": 1075,
    "high": 1098.81,
    "close": 1093.48,
    "volume": 56216432
  },
  {
    "date": "2025-12-15 23:30:00",
    "open": 1093.48,
    "low": 1084.61,
    "high": 1125.46,
    "close": 1108.16,
    "volume": 56825066
  },
  {
    "date": "2025-12-15 23:45:00",
    "open": 1108.16,
    "low": 1097.19,
    "high": 1116.08,
    "close": 1100.71,
    "volume": 54920314
  },
  {
    "date": "2025-12-16 00:00:00",
    "open": 1100.71,
    "low": 1092.48,
    "high": 1106.74,
    "close": 1094.1,
    "volume": 45448080
  }
]